import { Box, Flex, Text } from "@chakra-ui/react";
import { MODEL_NAMES } from "@root/constants";
import React from "react";

interface ModelDisplayProps {
  modelKey: number;
}



export default function ModelDisplay({ modelKey }: ModelDisplayProps) {
  const modelName = MODEL_NAMES[modelKey] || "UNKNOWN MODEL";

  return (
    <Box
      height={{ base: "36px", md: "40px" }}
      px={{ base: 3, md: 4 }}
      bg="#FFFFFF"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="lg"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
    >
      <Text
        fontSize={{ base: "12px", md: "14px" }}
        fontWeight="500"
        color="#1A1A1A"
      >
        {modelName}
      </Text>
    </Box>
  );
}